<template>
  <layout-register :step="step" :title-step="$t('m78')">
    <template #description-page>
      Cómo indica la imagen, sitúa tu dispositivo a la altura de tu rostro.
      <br />
      Evita elementos extra como lentes o gorros
    </template>
    <div class="row">
      <div class="col-md-6 col-12">
        <a-toc-container
          icon="ic-camera"
          background="selfie-front"
          label="Verificación facial"
          :img="form.selfie.value"
          :error="
            form.selfie.error.length > 0 || form.idLiveness.error.length > 0
          "
          :errorMessage="
            form.selfie.error ? form.selfie.error : form.idLiveness.error
          "
          @actuated="goesTo('liveness')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-10 mx-auto">
        <p class="mb-4 md-text-center">
          <a-icon name="ic-ayuda" />
          <a role="button" tabindex="0" @click="modal = true">
            ¿Porqué me piden verificación facial?
          </a>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7 col-xs-12 col-sm-12 col-12">
        <a-btn
          class="next-step-button"
          primary
          @click="sendSelfie"
          :loading="loadingBtn"
        >
          {{ $t('m15') + ' 7' }}
        </a-btn>
      </div>
    </div>

    <a-modal v-if="modal" @close="modal = false">
      <div slot="header">
        <h2>
          ¿Porqué me piden verificación facial?
        </h2>
        <p class="description">
          Solicitamos la verificación Facial-ID con TOC para verificar la
          identidad de las personas comparadas con los de la cédula de
          identidad. Esto nos permite la seguridad de los datos, como también,
          gestionar de forma óptima el servicio y la experiencia de los
          clientes.
        </p>
      </div>
      <div slot="body">
        <div class="primary--text font-weight-bold">
          Instrucciones para verificación facial
        </div>
        <hr />
        <div class="intructions">
          <a-icon name="ic-help-toc-pos" />
          <p>
            Sitúa la cámara de tu dispositivo a la altura de tu rostro
          </p>
        </div>
        <div class="intructions">
          <a-icon name="ic-help-toc-blight" />
          <p>
            Evita ubicarte a contraluz
          </p>
        </div>
        <div class="intructions">
          <a-icon name="ic-help-toc-background" />
          <p>
            Evita fondos similares al color de tu rostro
          </p>
        </div>
        <div class="intructions">
          <a-icon name="ic-help-toc-hat" />
          <p>
            Evita elementos extra, como gorros o lentes
          </p>
        </div>
      </div>
      <div slot="footer"></div>
    </a-modal>
    <a-modal class="modal-md" v-if="tocModal" @close="tocModal = false">
      <div slot="body">
        <div id="toc-container"></div>
      </div>
      <div slot="footer"></div>
    </a-modal>
  </layout-register>
</template>

<script>
import { validator } from '@/mixins/validator.js';
import { toc } from '@/mixins/toc.js';
import { imageConverter } from '@/mixins/imageConverter.js';
import AModal from '@/components/ui/AModal';
import AIcon from '@/components/ui/AIcon';
import ATocContainer from '@/components/ui/ATocContainer';
import ABtn from '@/components/ui/ABtn';

export default {
  name: 'DocumentSelfie',
  components: {
    AModal,
    ATocContainer,
    AIcon,
    ABtn,
  },
  mixins: [toc, imageConverter, validator],
  data() {
    return {
      modal: false,
      step: 6,
      loadingBtn: false,
    };
  },
  methods: {
    async sendSelfie() {
      if (this.validateForm()) {
        let selfieBlob = await this.srcToBlob(
          this.form.selfie.value,
          'image/jpeg',
          0.1,
        );
        const formData = new FormData();
        formData.append('fileSelfie', selfieBlob);
        formData.append('selfie', this.form.idLiveness.value);

        this.loadingBtn = true;
        this.$store.dispatch('register/tocSelfie', formData).then(resp => {
          this.loadingBtn = false;
          if (resp.registrationStep) {
            this.$router.push({ name: resp.registrationStep });
          }
        });
      }
    },
  },
  mounted() {
    this.form.selfie.rules = [this.rules.required];
    this.form.idLiveness.rules = [this.rules.required];
    this.documentTypeId =
      this.$store.getters['register/documentTypeId'] === 1 ? 'CHL1' : 'CHL2';
  },
};
</script>
